function FrihedenLogo() {
  return (
    <img
      height="200"
      width="200"
      src="/logos/friheden-logo.gif"
      className="w-full h-full object-contain"
      alt="Friheden Logo"
      loading="eager"
      decoding="async"
    />
  );
}

export { FrihedenLogo };
